import { createFileRoute } from '@tanstack/react-router';

import { GraphSetupSteps } from '@/components/features/data-harmonization/dashboard/graphs/setup/GraphSteps/GraphSetupSteps';
import { DHPageAccessProvider } from '@/components/features/data-harmonization/providers/DHPageAccessProvider';

export const Route = createFileRoute(
  '/_protected/t/$tenantId/data-harmonization/dashboard/$dashboardId/graph-setup/$graphId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { dashboardId, graphId } = Route.useParams();

  return (
    <DHPageAccessProvider permission="page:graph-setup" isLoading={false} dashboardId={dashboardId}>
      <GraphSetupSteps dashboardId={dashboardId} graphId={graphId} />
    </DHPageAccessProvider>
  );
}
